import { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { selectActivePromos } from "../../store/slices/promoSlice";
import { selectSaleItemList } from "../../store/slices/saleItemListSlice";
import { selectCategoryList } from "../../store/slices/categoryListSlice";
import { getMainScreenVariant } from "../../config/runtimeConfig";

export const useMainScreen = () => {
  const [selectedCategory, setSelectedCategory] = useState<number>();
  const activePromos = useSelector(selectActivePromos);

  // Фильтруем акции по isVisible и сортируем по sortOrder
  const promoList = useMemo(() => {
    return activePromos
      .filter((promo) => promo.isVisible !== false)
      .sort((a, b) => {
        const orderA = a.sortOrder ?? 0;
        const orderB = b.sortOrder ?? 0;
        return orderA - orderB;
      });
  }, [activePromos]);

  const list = useSelector(selectSaleItemList) || [];
  const rawCategoryList = useSelector(selectCategoryList) || [];

  // Сортируем категории по sortOrder
  const categoryList = useMemo(() => {
    return [...rawCategoryList].sort((a, b) => {
      const orderA = a.sortOrder ?? 0;
      const orderB = b.sortOrder ?? 0;
      return orderA - orderB;
    });
  }, [rawCategoryList]);

  const variant = getMainScreenVariant();

  const getCategoryName = (id: number) => {
    return categoryList.find((el) => el.id === id)?.name || "";
  };

  return {
    list,
    categoryList,
    promoList,
    selectedCategory,
    setSelectedCategory,
    getCategoryName,
    variant,
  };
};
